import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { QUALITY_STATUS_NAMES } from 'Core/constants/constants';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectQualityApprovalData = state => selectState(state).data;
export const selectQualityApprovalLoading = state => selectState(state).loading;
export const selectQualityApprovalError = state => selectState(state).error;
export const selectQualityApprovalFilterVisible = state => selectState(state).filterVisible;
export const selectQualityApprovalFilters = state => selectState(state).filters;
export const selectFilterVisible = state => selectState(state).filterVisible;
export const selectTileView = state => selectState(state).tileView;
export const selectedPart = state => selectState(state).selectedQualityApproval;
export const qualityApprovalData = state => selectState(state).qualityApprovalData;
export const qualityApprovalDataFilters = state => selectState(state).qualityApprovalDataFilters;
export const qualityApprovalDataSortKey = state => selectState(state).qualityApprovalDataSortKey;
export const selectFilteredQualityApprovals = createSelector(
  [selectQualityApprovalData, selectQualityApprovalFilters],
  (data, { searchText }) => {
    return data.filter(entry =>
      Object.keys(entry).some(key =>
        String(entry[key]).toLowerCase().includes(searchText.toLowerCase()),
      ),
    );
  },
);
export const selectFilteredQualityData = createSelector(
  [qualityApprovalData, qualityApprovalDataFilters, qualityApprovalDataSortKey],
  (data, { searchText }, qualityApprovalDataSortKey) => {
    const sortkey = qualityApprovalDataSortKey.value;
    const unsortedList = data.filter(entry => {
      return Object.keys(entry).some(key =>
        String(entry[key]).toLowerCase().includes(searchText.toLowerCase()),
      );
    });
    console.log('unsortedList => ', unsortedList);
    const sortedList = unsortedList.sort((a, b) => {
      if (sortkey == 'statusId') {
        const lcA = QUALITY_STATUS_NAMES[a[sortkey]].toLowerCase();
        const lcB = QUALITY_STATUS_NAMES[b[sortkey]].toLowerCase();
        return lcA < lcB ? -1 : lcA > lcB ? 1 : 0;
      } else {
        const lcA = a[sortkey].toLowerCase();
        const lcB = b[sortkey].toLowerCase();
        return lcA < lcB ? -1 : lcA > lcB ? 1 : 0;
      }
    });
    return sortedList;
  },
);
